// src/components/GridView/GridViewContext.ts
import { createContext, useContext } from 'react';
import type { ConversationDetail } from '@/types/conversation';
import type { ActionMenuConfig } from '@components/CalendarView/types';

export interface GridViewContextValue {
  conversations: ConversationDetail[];
  onOpenInfoWindow?: (conversation: ConversationDetail) => void;
  onUpdateConversation?: (conversationId: number, updates: Partial<ConversationDetail>) => void;
  onRenameTitle?: (conversationId: number, newTitle: string) => void;
  onRedFlagToggle?: (conversationId: number, isRedFlag: boolean) => void;
  onImportantToggle?: (conversationId: number, isImportant: boolean | null) => void;
  onDeleteConversation?: (conversationId: number) => void;
  onDuplicateConversation?: (e: any, conversation: any) => void;
  actionMenuConfig?: ActionMenuConfig;
}

export const GridViewContext = createContext<GridViewContextValue>({ conversations: [] });

export const useGridViewContext = (): GridViewContextValue => useContext(GridViewContext);
